import { Code2, Trophy, Users, Rocket, ExternalLink } from 'lucide-react';

const DCIC = () => {
  return (
    <div className="page-wrapper fade-in">
      <title>DCIC - Pidesk</title>
      <meta name="description" content="Developer Community of Innovation & Contribution, powered by Pidesk." />

      <section className="section bg-secondary" style={{ paddingBottom: '40px' }}>
        <div className="container" style={{ textAlign: 'center', maxWidth: '800px' }}>
          <div className="badge badge-accent fade-in">Developer Club</div>
          <h1 className="section-title fade-in" style={{ fontSize: '3.5rem', marginTop: '24px' }}>DCIC Community</h1>
          <p className="section-subtitle fade-in" style={{ margin: '24px auto', fontSize: '1.25rem' }}>
            Developer Community of Innovation and Contribution
          </p>
          <p className="fade-in" style={{ color: 'var(--text-secondary)', lineHeight: 1.8, marginBottom: '40px' }}>
            Powered by Pidesk, DCIC is a thriving ecosystem where passionate developers collaborate, participate in events, hackathons, and innovation programs to shape the future of technology.
          </p>
          <a href="https://dcic.pidesk.in" target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-lg btn-icon fade-in">
            Visit DCIC Community <ExternalLink size={18} />
          </a>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '32px' }}>
            {[
              { icon: <Trophy />, title: 'Hackathons', desc: 'Compete in our regular coding challenges and win prizes.' },
              { icon: <Code2 />, title: 'Coding Events', desc: 'Workshops, bootcamps, and live coding sessions with industry experts.' },
              { icon: <Users />, title: 'Collaboration', desc: 'Find co-founders and team members for your next big idea.' },
              { icon: <Rocket />, title: 'Incubation', desc: 'Get funding opportunities and mentorship from Pidesk to launch your startup.' }
            ].map((item, i) => (
              <div key={i} className="glass hover-lift" style={{ padding: '32px', borderRadius: '16px', border: '1px solid var(--border-color)' }}>
                <div style={{ width: '48px', height: '48px', borderRadius: '12px', backgroundColor: 'var(--bg-secondary)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--accent-highlight)', marginBottom: '24px' }}>
                  {item.icon}
                </div>
                <h3 style={{ fontSize: '1.25rem', marginBottom: '12px' }}>{item.title}</h3>
                <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6 }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default DCIC;
